export enum UserStatus {
  INDIVIDUAL = "INDIVIDUAL",
  ENTREPRENEUR = "ENTREPRENEUR",
  LEGAL_ENTITY = "LEGAL_ENTITY",
}
